import { State } from '@meraki-internal/state';
import { AircraftNotesModelFactory } from '../fleet/AircraftNotesModelFactory';
import { FleetManagementState } from './FleetManagementState';
import { IAttachment } from '../notes/NotesClient';
import { IAircraftNoteType } from './IAircraftNote';

export interface ILogEntry {
    id: string;
    title: string;
    type: IAircraftNoteType | 'mission';
    dateTime: string;
    attachments: IAttachment[];
}

export class AircraftLogState extends State<Record<string, never>> {

    static inject = () => [
        FleetManagementState,
        AircraftNotesModelFactory
    ];
    constructor(
        private fleetState: FleetManagementState,
        private notesFactory: AircraftNotesModelFactory
    ) {
        super({});

        fleetState.subscribe(() => {
            this.setState({});
        });

        notesFactory.subscribe(() => {
            this.setState({});
        });
    }

    getEntries = (aircraftId: string) => {
        const aircraft = this.fleetState.getAircraft(aircraftId);
        const model = this.notesFactory.forAircraft(aircraftId);

        if (!aircraft || !model.hasLoaded) {
            return undefined;
        }

        const notes = [...model.getNotes()];
        const missions = this.fleetState.getAllMissions(aircraft!);

        const entries: ILogEntry[] = [
            ...notes.map(n => ({ id: n.noteId, title: n.title, type: n.otherAttributes.type, dateTime: n.otherAttributes.dateTime, attachments: n.attachments })),
            ...missions.map(m => ({ id: m.state.missionId, title: m.getName(), type: 'mission' as const, dateTime: m.getStartTime(), attachments: [] }))
        ];

        entries.sort((e1, e2) => e2.dateTime.localeCompare(e1.dateTime));

        return entries;
    };

    reload = async (aircraftId: string) => {
        const model = this.notesFactory.forAircraft(aircraftId);
        await model.load();
    };
}
